"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const Client_1 = require("./Client");
class TrackProducer {
    constructor(track, producer) {
        this.track = track;
        this.producer = producer;
    }
}
class ProducerClient extends Client_1.Client {
    constructor(url, userId, logger) {
        super(url, userId, userId, "producer", logger);
        this.logger = logger;
        this.producers = {};
        this.on("close", (error) => {
            var _a;
            (_a = this.logger) === null || _a === void 0 ? void 0 : _a.log("[PRODUCER CLIENT] - on.close", Object.assign(Object.assign({}, this.loggerContext()), { error }));
            this.producers = {};
            this.signalingProducer = undefined;
        });
    }
    produceAllTracks(transport, tracks, type) {
        return __awaiter(this, void 0, void 0, function* () {
            for (let i = 0; i < tracks.length; i++) {
                this.producers[tracks[i].id] = yield transport.produce({
                    track: tracks[i],
                    stopTracks: false,
                    appData: { trackId: tracks[i].id, type }
                }).then(p => {
                    return new TrackProducer(tracks[i], p);
                });
            }
        });
    }
    init(transport) {
        return __awaiter(this, void 0, void 0, function* () {
            transport.on("produce", (parameters, callback, errback) => __awaiter(this, void 0, void 0, function* () {
                var _a;
                (_a = this.logger) === null || _a === void 0 ? void 0 : _a.log(`[PRODUCER CLIENT] - ready to produce stream ${this.userId}_${parameters.appData.trackId}_${parameters.appData.type} on transport ${transport.id}`, parameters);
                try {
                    const { id } = yield this.serverProduceStream({
                        id: `${this.userId}_${parameters.appData.trackId}_${parameters.appData.type}`,
                        kind: parameters.kind,
                        rtpParameters: parameters.rtpParameters
                    });
                    callback({ id });
                }
                catch (error) {
                    errback(error);
                }
            }));
            transport.on("producedata", (parameters, callback, errback) => __awaiter(this, void 0, void 0, function* () {
                var _b, _c;
                (_b = this.logger) === null || _b === void 0 ? void 0 : _b.log(`[PRODUCER CLIENT] - ready to produce data ${this.userId}_${parameters.label} on transport ${transport.id}`, parameters);
                try {
                    const { id } = yield this.serverProduceData({
                        id: `${this.userId}_${parameters.label}`,
                        sctpStreamParameters: parameters.sctpStreamParameters,
                        label: parameters.label,
                        protocol: parameters.protocol
                    });
                    callback({ id });
                }
                catch (error) {
                    (_c = this.logger) === null || _c === void 0 ? void 0 : _c.log("[PRODUCER CLIENT]: ERROR - on.producedata", { error });
                    errback(error);
                }
            }));
            return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                var _d, _e;
                (_d = this.logger) === null || _d === void 0 ? void 0 : _d.log("[PRODUCER CLIENT] - connecting data producer on transport " + transport.id, this.loggerContext());
                try {
                    this.signalingProducer = yield transport.produceData({ label: "signaling" });
                    const pendingTracks = Object.values(this.producers).map(p => p.track);
                    if (pendingTracks.length > 0) {
                        this.producers = {};
                        this.produceStream(pendingTracks).catch(ignored => { });
                    }
                    const client = this;
                    const currentSignalingProducer = this.signalingProducer;
                    (function keepAlive() {
                        if (currentSignalingProducer !== client.signalingProducer)
                            return;
                        if (client.signalingProducer.readyState !== "open") {
                            setTimeout(keepAlive, 1000);
                            return;
                        }
                        client.producersUpdated()
                            .then(() => setTimeout(keepAlive, 1000))
                            .catch(e => {
                            var _a;
                            (_a = client.logger) === null || _a === void 0 ? void 0 : _a.log("[PRODUCER CLIENT]: ERROR - producersUpdated on transport " + transport.id, { error: e });
                            throw e;
                        });
                        resolve();
                    })();
                }
                catch (e) {
                    (_e = this.logger) === null || _e === void 0 ? void 0 : _e.log("[PRODUCER CLIENT]: ERROR - connecting data producer on transport " + transport.id, { error: e });
                    reject(e);
                }
            }));
        });
    }
    producersUpdated() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.sendRawData({
                type: "update-producers",
                producers: Object.values(this.producers).reduce((res, producer) => { res.push(producer.producer.id); return res; }, [])
            });
        });
    }
    produceStream(tracks) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            (_a = this.logger) === null || _a === void 0 ? void 0 : _a.log("[PRODUCER CLIENT] - produceStream", { tracks: tracks.map(i => ProducerClient.filterEntityFields(i, ["kind", "readyState", "id", "isolated", "label", "muted", "enabled"])) });
            const transport = yield this.awaitConnected();
            const newTracks = tracks.filter(track => this.producers[track.id] === undefined);
            const tracksToClose = Object.values(this.producers).map(producer => producer.track).filter(track => {
                return tracks.find(t => t.id === track.id) === undefined;
            });
            // TODO: принимать типы треков с клиентского кода, чтобы можно было разделять треки video/screen sharing
            yield this.produceAllTracks(transport, newTracks.filter(track => track.kind === "video"), "video");
            yield this.produceAllTracks(transport, newTracks.filter(track => track.kind === "audio"), "audio");
            yield this.closeStream(tracksToClose);
            tracksToClose.forEach(t => t.stop());
        });
    }
    closeStream(tracks) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            (_a = this.logger) === null || _a === void 0 ? void 0 : _a.log("[PRODUCER CLIENT] - closeStream", { tracks: tracks.map(i => ProducerClient.filterEntityFields(i, ["kind", "readyState", "id", "isolated", "label", "muted", "enabled"])) });
            const producersToClose = [];
            for (const track of tracks) {
                const producer = this.producers[track.id];
                if (producer) {
                    delete this.producers[track.id];
                    producersToClose.push(producer);
                }
            }
            for (const producer of producersToClose) {
                producer.producer.close();
                yield this.serverCloseStream({ producerId: producer.producer.id });
            }
        });
    }
    sendRawData(data) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.awaitConnected();
            if (!this.signalingProducer)
                return;
            this.signalingProducer.send(JSON.stringify(data));
        });
    }
    sendData(data) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.sendRawData({ type: "app-data", data });
        });
    }
    getProducerStats(track) {
        return __awaiter(this, void 0, void 0, function* () {
            const producer = this.producers[track.id];
            if (!producer)
                return Promise.reject();
            return Array.from((yield producer.producer.getStats()).values());
        });
    }
    static filterEntityFields(entity, fields) {
        const acc = {};
        for (const e in entity) {
            if (fields.includes(e))
                acc[e] = entity[e];
        }
        return acc;
    }
    loggerContext() {
        return Object.entries(this.producers).reduce((res, [id, value]) => {
            res[id] = {
                track: {
                    id: value.track.id,
                    kind: value.track.kind,
                    label: value.track.label,
                    readyState: value.track.readyState,
                },
                producer: {
                    appData: value.producer.appData,
                    kind: value.producer.kind,
                    localId: value.producer.localId,
                    paused: value.producer.paused,
                }
            };
            return res;
        }, {});
    }
}
exports.ProducerClient = ProducerClient;
